import { ERROR_MESSAGES, REQUIRED_PREFIX_PUBLISHERS, UID_PREFIX } from '@/constants/error'
import { TARGET_PAGES, type TargetPageType } from '@/constants/routes'
import type { Publisher } from '@/types/supports'

import { BridgeError } from './errors'

export function assertPublisher(publisher: Publisher | undefined): asserts publisher is Publisher {
  if (!publisher) {
    throw new BridgeError({
      title: 'Publisher 정보를 찾을 수 없습니다.',
      subtitle: ERROR_MESSAGES.DEFAULT
    })
  }
}

export function assertUid(uid: string | null, publisher: Publisher): asserts uid is string {
  if (!uid) {
    throw new BridgeError({
      title: ERROR_MESSAGES.MISSING_UID,
      subtitle: ERROR_MESSAGES.DEFAULT,
      publisher: publisher.code
    })
  }
}

export function assertUidPrefix(uid: string, publisher: Publisher): void {
  const requiresPrefix = REQUIRED_PREFIX_PUBLISHERS.includes(publisher.code)

  if (requiresPrefix && !uid.startsWith(UID_PREFIX)) {
    throw new BridgeError({
      title: 'UID prefix 검증 실패',
      subtitle: ERROR_MESSAGES.INVALID_UID_PREFIX,
      publisher: publisher.code
    })
  }
}

export function assertValidTarget(target: string | null, publisher: Publisher): asserts target is TargetPageType {
  const isValidTarget = target && Object.values(TARGET_PAGES).includes(target as TargetPageType)

  if (!isValidTarget) {
    throw new BridgeError({
      title: ERROR_MESSAGES.PAGE_NOT_FOUND,
      subtitle: ERROR_MESSAGES.DEFAULT,
      publisher: publisher.code
    })
  }
}
